<template>
	<!-- @close="close" -->
	<el-dialog :visible="visible" append-to-body width="1000px" :close-on-click-modal="false" lock-scroll
		:show-close="false">
		<div class="padding30 flex-columnCenter">
			<div class="margin-bottom20 font25">请选择你所在的高考省份</div>
			<div class="flex-wrap">
				<div class="province_item "
					:class="provinceId==item.id?'bg-blue-opa border-blue color-blue':item.is_config?'border':'bg-grey'"
					v-for="(item,index) in provinceList" :key="index" @click="itemChange(item)">
					{{item.name }}
				</div>
			</div>
			<el-button type="primary" class="width200 border-radius6 bg-blue border-blue margin-top40"
				@click="handleConfirm">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {
		province,
		preprovince,
	} from '@/api/com'

	export default {
		name: 'GlobalProvince',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				provinceName: '',
				provinceId: '',
				provinceList: []
			}
		},
		created() {
			this.getProvinceList()
		},
		// 监听弹窗显示，自动选中本地已有省份
		watch: {
			visible(newVal) {
				if (newVal) {
					const localId = localStorage.getItem('provinceId')
					const localName = localStorage.getItem('provinceName')
					if (localId) {
						this.provinceId = localId
						this.provinceName = localName
					}
				}
			}
		},
		methods: {
			itemChange(item) {
				if (item.is_config) {
					this.provinceName = item.name
					this.provinceId = item.id
				}

			},
			getProvinceList() {
				province().then(res => {
					sessionStorage.setItem('provinceList', JSON.stringify(res.data))
				})
				preprovince().then(res => {
					this.provinceList = res.data
				})
			},
			handleConfirm() {
				localStorage.setItem('provinceName', this.provinceName)
				localStorage.setItem('provinceId', this.provinceId)
				this.$bus.$emit('provinceIdChanged', this.provinceId)
				this.$emit('confirm', this.provinceName, this.provinceId)
			},
			close() {
				this.$emit('close')
			},
		}
	}
</script>


<style scoped lang="scss">
	.province_item {
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		padding: 0 30px;
		margin: 10px;
		border-radius: 4px;
		cursor: pointer;
	}

	.province_item.bg-grey {
		cursor: no-drop;
	}
</style>